import PropTypes from "prop-types"
import pluralize from "pluralize"
import { size, map } from "lodash"
import { USER } from "helpers/shapes"
import Token from "../token"
import IconButton from "@mui/material/IconButton"
import { Widgets, Add } from "@mui/icons-material"
import "./style.scss"
import { APPLICATION } from "../../shapes"

export default function App({
  app: { id, name, tokens },
  user,
  account,
  addNotification,
  deleteTokenHandler,
  renameTokenHandler,
  createTokenHandler,
}) {
  const nbTokens = size(tokens)

  return <div className="app-card">
    <div className="header">
      <Widgets color="primary" />
      <div className="name-wrapper">
        <div className="name">{name}</div>
      </div>
    </div>
    <hr />
    <div className="tokens">
      <div className="header">
        <span>{`${nbTokens} ${pluralize("key", nbTokens)}`}</span>
        <IconButton
          className="add"
          color="primary"
          aria-label="add"
          onClick={() => createTokenHandler(id)}
          size="large"
        >
          <Add />
        </IconButton>
      </div>
      <ul className="tokens-list">
        {map(tokens, (token) =>
          <li className="tokens-list-item" key={token.id}>
            <Token
              token={token}
              user={user}
              account={account}
              addNotification={addNotification}
              deleteTokenHandler={deleteTokenHandler}
              renameTokenHandler={renameTokenHandler}
            />
          </li>,
        )}
      </ul>
    </div>
  </div>
}

App.propTypes = {
  app: APPLICATION.isRequired,
  createTokenHandler: PropTypes.func.isRequired,
  renameTokenHandler: PropTypes.func.isRequired,
  addNotification: PropTypes.func.isRequired,
  deleteTokenHandler: PropTypes.func.isRequired,
  account: PropTypes.string.isRequired,
  user: USER.isRequired,
}
